/* eslint-disable max-len */
/* eslint-disable sort-keys */

// WIP prop103
const planTypeInfo = [
  {
    coveredItems: [
      'Accidents',
      'Hereditary Issues',
      'Behavioral Issues',
      'Illnesses',
      'Dental Disease',
      'And More',
    ],
    description: 'For when your pet is hurt or sick',
    icon: '/static/media/icon-heart-beat.860d6ff71e3634e71d0a27f27017a848.svg',
    id: 1,
    monthly: true,
    title: 'Accident & Illness',
  },
  {
    coveredItems: [
      'Injuries and emergencies related to accidents',
    ],
    description: 'For when your pet is hurt',
    icon: '/static/media/icon-heart-shine.759d098b1ab37069c9ee91bc785c1ecc.svg',
    id: 2,
    monthly: true,
    title: 'Accident Only',
  },
];

const powerUpInfo = {
  AppText: 'Preventive',
  BenefitFeeType: 2,
  BenefitParentId: null,
  BenefitType: 2,
  BundleInsuranceModifiers: [
    {
      AppText: null,
      BenefitFeeType: null,
      BenefitParentId: 330,
      BenefitType: null,
      BundleInsuranceModifiers: null,
      CoverageLimitId: 77,
      CreatedOn: '2026-07-21T17:40:29.89',
      FeeAmount: 7.78,
      Id: 335,
      Image: null,
      InformationText: '',
      InputText: 'For the pet parent who stays ahead of the basics. This plan helps cover routine essentials like vaccines, exams, and tests-solid, reliable care without the extras.',
      InsuranceModifierDiscount: null,
      InsuranceModifierType: {
        DisplayName: '',
        Id: 5,
        Name: 'Coverage',
      },
      InsuranceModifierTypeId: 5,
      InsuranceProductId: 19,
      IsActive: true,
      IsSelected: false,
      IsVisible: true,
      MaximumAnnualBenefit: 250,
      OptionalBenefitsDetailsItem: [],
      OrderNumber: 14,
      PMSModifierId: null,
      QuestionType: 0,
      TitleText: 'Basic',
    },
    {
      AppText: null,
      BenefitFeeType: null,
      BenefitParentId: 330,
      BenefitType: null,
      BundleInsuranceModifiers: null,
      CoverageLimitId: 75,
      CreatedOn: '2026-07-21T17:40:29.89',
      FeeAmount: 19.5,
      Id: 336,
      Image: null,
      InformationText: '',
      InputText: 'For pet parents who like a little more cushion. Prime covers everything in Basic-plus higher limits across the board-so routine care stays easy, even when needs add up.',
      InsuranceModifierDiscount: null,
      InsuranceModifierType: {
        DisplayName: '',
        Id: 5,
        Name: 'Coverage',
      },
      InsuranceModifierTypeId: 5,
      InsuranceProductId: 19,
      IsActive: true,
      IsSelected: false,
      IsVisible: true,
      MaximumAnnualBenefit: 450,
      OptionalBenefitsDetailsItem: [],
      OrderNumber: 15,
      PMSModifierId: null,
      QuestionType: 0,
      TitleText: 'Prime',
    },
  ],
  CoverageLimitId: null,
  CreatedOn: '2021-05-11T23:11:39.12',
  FeeAmount: null,
  Id: 330,
  Image: '/Content/Images/PowerUps/wellnes.png',
  InformationText: 'Routine care coverage, including dental, can be added to any plan to help pay for vaccinations, spay/neuter, bloodwork, heartworm preventive, and more. Coverage amounts based on benefit schedule.',
  InputText: 'Helps cover routine care like vaccines, cleanings, yearly exams, and more! Works separately from your main plan and doesn’t apply to your deductible.',
  InsuranceModifierDiscount: null,
  InsuranceModifierType: {
    DisplayName: '',
    Id: 5,
    Name: 'Coverage',
  },
  InsuranceModifierTypeId: 5,
  InsuranceProductId: 19,
  IsActive: true,
  IsSelected: false,
  IsVisible: true,
  MaximumAnnualBenefit: null,
  OptionalBenefitsDetailsItem: [],
  OrderNumber: 2,
  PMSModifierId: 70428,
  QuestionType: 0,
  TitleText: 'Preventive',
};

const multiModalData = {
  Id: 2,
  InsuranceMultiModalCategoryDtoList: [
    {
      CategoryHeader: 'Wellness - Basic',
      Id: 15,
      ImageUrl: null,
      InsuranceMultiModalItemsDtoList: [
        {
          BulletIconUrl: null,
          CategoryId: 15,
          Id: 32137,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'Helps Cover',
          ItemSubText: null,
          OrderId: 1,
          OrderParentId: null,
          SectionId: 2,
          Value: 'Up to',
          PetType: 0,
        },
        {
          BulletIconUrl: null,
          CategoryId: 15,
          Id: 32160,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'Helps Cover',
          ItemSubText: null,
          OrderId: 1,
          OrderParentId: null,
          SectionId: 2,
          Value: 'Up to',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/WellnessExam.svg',
          CategoryId: 15,
          Id: 32138,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Wellness Exam',
          ItemSubText: null,
          OrderId: 2,
          OrderParentId: null,
          SectionId: 2,
          Value: '$50/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/WellnessExam.svg',
          CategoryId: 15,
          Id: 32161,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Wellness Exam',
          ItemSubText: null,
          OrderId: 2,
          OrderParentId: null,
          SectionId: 2,
          Value: '$50/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/dental-tooth.svg',
          CategoryId: 15,
          Id: 32139,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Dental Cleaning',
          ItemSubText: null,
          OrderId: 3,
          OrderParentId: null,
          SectionId: 2,
          Value: '$100/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/dental-tooth.svg',
          CategoryId: 15,
          Id: 32162,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Dental Cleaning',
          ItemSubText: null,
          OrderId: 3,
          OrderParentId: null,
          SectionId: 2,
          Value: '$100/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 15,
          Id: 32140,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Deworming',
          ItemSubText: null,
          OrderId: 4,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 15,
          Id: 32163,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Deworming',
          ItemSubText: null,
          OrderId: 4,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 15,
          Id: 32141,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'DHLPP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 5,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 15,
          Id: 32164,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'FVRCP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 5,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 15,
          Id: 32142,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Rabies or Lyme Vaccine/Titer',
          ItemSubText: null,
          OrderId: 6,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 15,
          Id: 32165,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Rabies or FIP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 6,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/HeartwormTest.svg',
          CategoryId: 15,
          Id: 32143,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Heartworm Test',
          ItemSubText: null,
          OrderId: 7,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 15,
          Id: 32166,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'FeLV Test',
          ItemSubText: null,
          OrderId: 7,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 15,
          Id: 32144,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Fecal Test',
          ItemSubText: null,
          OrderId: 8,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 15,
          Id: 32167,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Fecal Test',
          ItemSubText: null,
          OrderId: 8,
          OrderParentId: null,
          SectionId: 2,
          Value: '$20/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: null,
          CategoryId: 15,
          Id: 32145,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'We Reimburse Up To',
          ItemSubText: null,
          OrderId: 9,
          OrderParentId: null,
          SectionId: 2,
          Value: '$250/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: null,
          CategoryId: 15,
          Id: 32168,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'We Reimburse Up To',
          ItemSubText: null,
          OrderId: 9,
          OrderParentId: null,
          SectionId: 2,
          Value: '$250/yr',
          PetType: 1,
        },
      ],
      IsMobile: true,
      SubTitle: 'This Powerup covers you up to the annual limit stated under each expense, aka the maximum amount that Figo will reimburse you per year.',
    },
    {
      CategoryHeader: 'Wellness - Plus',
      Id: 16,
      ImageUrl: null,
      InsuranceMultiModalItemsDtoList: [
        {
          BulletIconUrl: null,
          CategoryId: 16,
          Id: 32146,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'Helps Cover',
          ItemSubText: null,
          OrderId: 1,
          OrderParentId: null,
          SectionId: 2,
          Value: 'Up to',
          PetType: 0,
        },
        {
          BulletIconUrl: null,
          CategoryId: 16,
          Id: 32169,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'Helps Cover',
          ItemSubText: null,
          OrderId: 1,
          OrderParentId: null,
          SectionId: 2,
          Value: 'Up to',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/WellnessExam.svg',
          CategoryId: 16,
          Id: 32147,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Wellness Exam',
          ItemSubText: null,
          OrderId: 2,
          OrderParentId: null,
          SectionId: 2,
          Value: '$50/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/WellnessExam.svg',
          CategoryId: 16,
          Id: 32170,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Wellness Exam',
          ItemSubText: null,
          OrderId: 2,
          OrderParentId: null,
          SectionId: 2,
          Value: '$50/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/dental-tooth.svg',
          CategoryId: 16,
          Id: 32148,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Dental Cleaning or Spay/Neuter',
          ItemSubText: null,
          OrderId: 3,
          OrderParentId: null,
          SectionId: 2,
          Value: '$150/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/dental-tooth.svg',
          CategoryId: 16,
          Id: 32171,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Dental Cleaning or Spay/Neuter',
          ItemSubText: null,
          OrderId: 3,
          OrderParentId: null,
          SectionId: 2,
          Value: '$150/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 16,
          Id: 32149,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Deworming',
          ItemSubText: null,
          OrderId: 4,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 16,
          Id: 32172,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Deworming',
          ItemSubText: null,
          OrderId: 4,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32150,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'DHLPP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 5,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32173,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'FVRCP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 5,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32151,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Rabies or Lyme Vaccine/Titer',
          ItemSubText: null,
          OrderId: 6,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32174,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Rabies or FIP Vaccine/Titer',
          ItemSubText: null,
          OrderId: 6,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/HeartwormTest.svg',
          CategoryId: 16,
          Id: 32152,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Heartworm Test',
          ItemSubText: null,
          OrderId: 7,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 16,
          Id: 32175,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'FeLV Test',
          ItemSubText: null,
          OrderId: 7,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 16,
          Id: 32153,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Fecal Test',
          ItemSubText: null,
          OrderId: 8,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/clipboard-medical.svg',
          CategoryId: 16,
          Id: 32176,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Fecal Test',
          ItemSubText: null,
          OrderId: 8,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32154,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Bordetella Vaccine/Titer',
          ItemSubText: null,
          OrderId: 9,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/medical-instrument-syringe-1.svg',
          CategoryId: 16,
          Id: 32177,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'FeLV Vaccine',
          ItemSubText: null,
          OrderId: 9,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 16,
          Id: 32155,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Flea/Heartworm Prevention',
          ItemSubText: null,
          OrderId: 10,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Vector.svg',
          CategoryId: 16,
          Id: 32178,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Flea/Heartworm Prevention',
          ItemSubText: null,
          OrderId: 10,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/HealthCertificate.svg',
          CategoryId: 16,
          Id: 32156,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Health Certificate',
          ItemSubText: null,
          OrderId: 11,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/HealthCertificate.svg',
          CategoryId: 16,
          Id: 32179,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Health Certificate',
          ItemSubText: null,
          OrderId: 11,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Test.svg',
          CategoryId: 16,
          Id: 32157,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Blood Test',
          ItemSubText: null,
          OrderId: 12,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Test.svg',
          CategoryId: 16,
          Id: 32180,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Blood Test',
          ItemSubText: null,
          OrderId: 12,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Test.svg',
          CategoryId: 16,
          Id: 32158,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Urinalysis',
          ItemSubText: null,
          OrderId: 13,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: 'https://sttstpetcloud.blob.core.windows.net/connect-media/petcloud/Content/Images/MultiModal/Test.svg',
          CategoryId: 16,
          Id: 32181,
          InsuranceProductId: null,
          IsBold: false,
          ItemLabel: 'Urinalysis',
          ItemSubText: null,
          OrderId: 13,
          OrderParentId: null,
          SectionId: 2,
          Value: '$25/yr',
          PetType: 1,
        },
        {
          BulletIconUrl: null,
          CategoryId: 16,
          Id: 32159,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'We Reimburse Up To',
          ItemSubText: null,
          OrderId: 14,
          OrderParentId: null,
          SectionId: 2,
          Value: '$450/yr',
          PetType: 0,
        },
        {
          BulletIconUrl: null,
          CategoryId: 16,
          Id: 32182,
          InsuranceProductId: null,
          IsBold: true,
          ItemLabel: 'We Reimburse Up To',
          ItemSubText: null,
          OrderId: 14,
          OrderParentId: null,
          SectionId: 2,
          Value: '$450/yr',
          PetType: 1,
        },
      ],
      IsMobile: true,
      SubTitle: 'This Powerup covers you up to the annual limit stated under each expense, aka the maximum amount that Figo will reimburse you per year.',
    },
  ],
  SectionName: 'Wellness Details',
};

export const prop103 = {
  id: 1,
  multiModalData,
  planTypeInfo,
  powerUpInfo,
};
